// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "hr[data-v-48608a1f]{width:64px;height:6px;border-radius:3px}", ""]);
// Exports
module.exports = exports;
